<template>
    <el-dialog
            title="查看明细"
            :visible.sync="detailVisible"
            append-to-body
            width="65%"
            :before-close="handleClose"
        >
          <div slot="title" >
            <span>查看明细</span>
            <span class="dia-num">总数量：{{ totalNum }}</span>
            <span class="dia-num">总方量(m³)：{{ totalAmount }}</span>
          </div>
            <el-table border :data="detailStatistics"  max-height="400">
                <el-table-column
                    property="customerItemCode"
                    label="客户商品编码"
                    width="130"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="itemName"
                    label="商品名称"
                    width="300"
                    sortable
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    property="planQty"
                    label="数量"
                    sortable
                ></el-table-column>
                <el-table-column
                    property="volume"
                    label="方量(m³)"
                    sortable
                ></el-table-column>
                <el-table-column
                    property="originTotalPlanQty"
                    label="拆单源商品总数"
                    sortable
                >
                <template slot-scope="scope">
                   {{ formatNumber(scope.row.originTotalPlanQty) }}
                </template>
                </el-table-column>
            </el-table>
        </el-dialog>
</template>
<script>
export default {
    props: {
        detailVisible: Boolean,
        totalNum: [Number, String],
        totalAmount: [Number, String],
        detailStatistics: Array
    },
    data () {
        return {

        };
    },
    methods: {
        handleClose () {
            this.$emit('update:detailVisible', false);
        },

        formatNumber (value) {
            if ([null, undefined, ''].includes(value)) {
                return '';
            } else {
                return parseFloat(value);
            }
        }
    }
};
</script>
<style scoped>
.dia-num {
    padding-left: 50px;
    font-size: 12px;
    color: #94979a;
}
</style>
